import React from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon, AlertTriangle, FileWarning, Shield, Activity } from 'lucide-react';

const TAG_ICON = {
  critical: AlertOctagon,
  warning: AlertTriangle,
  info: FileWarning,
  default: Activity,
};
const TAG_COLOR = {
  critical: 'text-apex-critical bg-red-50 border-red-200',
  warning: 'text-apex-warning bg-amber-50 border-amber-200',
  info: 'text-apex-lens bg-teal-50 border-teal-200',
  default: 'text-apex-neutral bg-slate-50 border-slate-200',
};

export default function InvestigationTimeline({ events = [] }) {
  return (
    <div className="space-y-0" data-testid="investigation-timeline">
      {events.map((e, i) => {
        const Icon = TAG_ICON[e.tag] ?? TAG_ICON.default;
        const colorClass = TAG_COLOR[e.tag] ?? TAG_COLOR.default;
        const isLast = i === events.length - 1;
        return (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="relative pl-9 pb-5"
          >
            <div className={`absolute left-0 top-0 w-7 h-7 rounded-full border flex items-center justify-center ${colorClass}`}>
              <Icon className="w-3.5 h-3.5" />
            </div>
            {!isLast && (
              <div className="absolute left-[13px] top-7 bottom-0 w-px bg-slate-200" />
            )}
            <div className="text-[10px] font-mono uppercase tracking-wider text-apex-neutral">{e.date}</div>
            <div className="text-sm font-semibold text-apex-ink mt-0.5">{e.title}</div>
            {e.detail && (
              <div className="text-xs text-apex-neutral mt-1 whitespace-pre-line leading-relaxed">{e.detail}</div>
            )}
            {e.trail && (
              <div className="mt-1 text-[10px] font-mono text-apex-lens">CloudTrail: {e.trail}</div>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
